import script from "./ArtifiDesignerPrototype.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtifiDesignerPrototype.vue?vue&type=script&setup=true&lang=js"

import "./ArtifiDesignerPrototype.vue?vue&type=style&index=0&id=8e6848a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e6848a6"]])

export default __exports__